"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _genericMetrics = _interopRequireDefault(require("./generic-metrics"));
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @description Util class to handle Buisness Metrics
 * @export
 * @class BusinessMetrics
 */
var BusinessMetrics = exports.default = /*#__PURE__*/function (_GenericMetrics) {
  (0, _inherits2.default)(BusinessMetrics, _GenericMetrics);
  var _super = _createSuper(BusinessMetrics);
  function BusinessMetrics() {
    (0, _classCallCheck2.default)(this, BusinessMetrics);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(BusinessMetrics, [{
    key: "submitCallEndEvent",
    value:
    /**
     * unfortunately, the pinot team does not allow changes to the schema of wbxapp_callend_metrics
     * so we have to shim this layer specifically for this
     * https://confluence-eng-gpk2.cisco.com/conf/display/WAP/Table+wbxapp_callend_metrics
     * @param {EventPayload} payload payload of the metric
     * @returns {Promise<any>}
     */
    function submitCallEndEvent(_ref) {
      var payload = _ref.payload;
      var event = {
        type: ['business'],
        eventPayload: {
          key: 'callEnd',
          client_timestamp: new Date().toISOString(),
          appType: 'Web Client',
          value: _objectSpread({}, payload)
        }
      };
      return this.submitEvent({
        kind: 'buisness-events:wbxapp_callend_metrics -> ',
        name: 'wbxapp_callend_metrics',
        event: event
      });
    }

    /**
     * Submit a buisness metric to our metrics endpoint, going to the default business_ucf table
     * all event payload keys are converted into a hex string value
     * unfortunately, the pinot team does not allow changes to the schema of business_metrics
     * so we have to shim this layer specifically for this
     * https://confluence-eng-gpk2.cisco.com/conf/display/WAP/Table%3A+business_metrics
     * @param {string} name of the metric
     * @param {EventPayload} payload payload of the metric
     * @returns {Promise<any>}
     */
  }, {
    key: "submitBusinessMetricsEvent",
    value: function submitBusinessMetricsEvent(_ref2) {
      var name = _ref2.name,
        payload = _ref2.payload;
      var event = {
        type: ['business'],
        eventPayload: {
          key: name,
          client_timestamp: new Date().toISOString(),
          appType: 'Web Client',
          value: _objectSpread(_objectSpread(_objectSpread({}, this.getContext()), this.getBrowserDetails()), payload)
        }
      };
      return this.submitEvent({
        kind: 'buisness-events:business_metrics -> ',
        name: name,
        event: event
      });
    }

    /**
     * Submit a buisness metric to our metrics endpoint, going to the default business_ucf table
     * all event payload keys are converted into a hex string value
     * https://confluence-eng-gpk2.cisco.com/conf/display/WAP/Business+metrics++-%3E+ROMA
     * @param {string} name of the metric
     * @param {EventPayload} user payload of the metric
     * @returns {Promise<any>}
     */
  }, {
    key: "submitDefaultEvent",
    value: function submitDefaultEvent(_ref3) {
      var name = _ref3.name,
        payload = _ref3.payload;
      var event = {
        type: ['business'],
        eventPayload: {
          key: name,
          appType: 'Web Client',
          client_timestamp: new Date().toISOString(),
          context: this.getContext(),
          browserDetails: this.getBrowserDetails(),
          value: payload
        }
      };
      return this.submitEvent({
        kind: 'buisness-events:default -> ',
        name: name,
        event: event
      });
    }

    /**
     * Submit a buisness metric to our metrics endpoint.
     * routes to the correct table with the correct schema payload by table
     * https://confluence-eng-gpk2.cisco.com/conf/display/WAP/Business+metrics++-%3E+ROMA
     * @param {string} name of the metric, ignored if going to wbxapp_callend_metrics
     * @param {EventPayload} payload user payload of the metric
     * @param {Table} table optional - to submit the metric to and adapt the sent schema
     * @returns {Promise<any>}
     */
  }, {
    key: "submitBusinessEvent",
    value: function submitBusinessEvent(_ref4) {
      var name = _ref4.name,
        payload = _ref4.payload,
        table = _ref4.table;
      if (!table) {
        table = 'default';
      }
      switch (table) {
        case 'wbxapp_callend_metrics':
          return this.submitCallEndEvent({
            payload: payload
          });
        case 'business_metrics':
          return this.submitBusinessMetricsEvent({
            name: name,
            payload: payload
          });
        case 'business_ucf':
          return this.submitDefaultEvent({
            name: name,
            payload: payload
          });
        case 'default':
        default:
          return this.submitDefaultEvent({
            name: name,
            payload: payload
          });
      }
    }
  }]);
  return BusinessMetrics;
}(_genericMetrics.default);
//# sourceMappingURL=business-metrics.js.map
